import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import AuthorizedCom from "./containers/AuthorizedCom";
import Login from "./containers/Login/Login";
import Register from "./register/Register";
import ForgotPassword from "./containers/Login/forgot_password";
import AccountReset from "./containers/Login/accountReset";
import CreateSuperAdmin from "./containers/CreateSuperAdmin/CreateSuperAdmin";
import PrivateRoute from "./PrivateRoute";

function App() {
  return (
    <AuthProvider>
    <div className="w-full bg-black">
      <Routes>
        {/* Public routes — no login needed */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin-account-reset" element={<AccountReset />} />
        <Route path="/create-super-admin" element={<CreateSuperAdmin />} />

        {/* Protected — requires accessToken in localStorage */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <AuthorizedCom />
            </PrivateRoute>
          }
        />

        {/* Catch-all fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
    </AuthProvider>
  );
}

export default App;